import React from 'react'

const DataIcon = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
  <path d="M25.25 25.25H10.5833C6.18356 25.25 3.98367 25.25 2.61683 23.8832C1.25 22.5163 1.25 20.3164 1.25 15.9167V1.25" stroke="#FF3B30" strokeWidth="2.5" strokeLinecap="round"/>
  <path d="M3.91602 23.9164C4.50185 19.708 7.48457 8.93541 11.1536 8.93541C13.6895 8.93541 14.3462 14.0967 16.8312 14.0967C21.1068 14.0967 20.487 2.58301 25.2493 2.58301" stroke="#FF3B30" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default DataIcon